import React from 'react';
import { img_path } from '../../../environment'
import { useState, useEffect } from "react";

interface Image {
  className?: string;
  src: string;
  alt?: string;
  height?: string;
  width?: string;
  id?: string;
}

const ImageWithBasePath = (props: Image) => {
  const defaultSrc = "../../assets/img/cars/no_image.svg"; // Fallback image
  const isRemote = props.src && (props.src.startsWith("http") || props.src.startsWith("//") || props.src.startsWith("blob:"));
  const fullSrc = props.src ? (isRemote ? props.src : `${img_path}${props.src}`) : defaultSrc;


  const [imgSrc, setImgSrc] = useState(fullSrc);

  useEffect(() => {
    setImgSrc(fullSrc); // Update imgSrc if props.src changes
  }, [props.src]);

  return (
    <img
      className={props.className}
      src={imgSrc}
      height={props.height}
      alt={props.alt || "Image"}
      width={props.width}
      id={props.id}
      onError={() => {
        if (imgSrc !== defaultSrc) {
          setImgSrc(defaultSrc); // Change to fallback image only once
        }
      }}
    />
  );
};


export default ImageWithBasePath;
